//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/blog'
import BlogItem from '../card/_components/_blog'
import search from '../card/_components/_search'
import { mapBlogs } from '@/views/house_circles/data_handle'
import { getPaginationMixin } from '@/common/mixins/pagination'
export default {
    components: {
        BlogItem,
        search
    },
    mixins: [
        getPaginationMixin({
            loading_name: 'feeds_loading'
        })
    ],
    data () {
        return {
            value: '',
            desc: '',
            loading: false
        }
    },
    methods: {
        onSearch(val) {
            this.page = 1
            this.getData(val)
        },
        getData (val) {
            const { consultant_id } = this.$root.$mp.query
            const params = {
                consultant_id: consultant_id,
                page: this.page,
                keyword: val
            }
            Service.getConsultantFeeds(params)
            .then(({ items }) => {
                this.handleData({ items: mapBlogs(items,'', val) })
                if (this.items.length === 0) {
                    this.desc = `没有找到“${val}”相关动态`
                    this.loading = true
                }
            })
        },
        handleItems (id, handler) {
            this.items.some((item, i) => {
                if (item.id === id) {
                    handler(i)
                    return true
                }
            })
        },
        onChangeFeed (item) {
            this.handleItems(item.id, (i) => {
                this.$set(this.items, i, item)
            })
        },
    }
}
